module.exports = __webpack_public_path__ + "static/img/tn.50cd9101.svg";